module.exports = __webpack_public_path__ + "static/lovie-95fde5c33ba3edecf7aea3d1e9d588f9.svg";